import styled from 'styled-components'

import { ImageWrapper as ImageWrapperUI, Title as TitleUI } from '../styles'

import { NormalizedWrapper as NormalizedWrapperUI } from '@theme'

export const ImageWrapper = styled(ImageWrapperUI)`
  height: 820px;

  ${({ theme }) => theme.below.laptopL`
    height: 620px;
  `}

  width: 100%;
`

export const Title = styled(TitleUI)`
  margin-bottom: 40px;
`

export const NormalizedWrapper = styled(NormalizedWrapperUI)`
  padding: 90px 0;
`
